{
  "accessDenied": "تم رفض الوصول",
  "action": "الإجراء",
  "active": "نشط",
  "address": "العنوان",
  "amount": "المبلغ",
  "appName": "منصة إكسالت",
  "apply": "تطبيق",
  "approved": "معتمد",
  "available": "المتاح",
  "back": "رجوع",
  "balance": "الرصيد",
  "cancel": "إلغاء",
  "cancelled": "ملغي",
  "cardProviderRequired": "مطلوب تكامل مزود الخدمة",
  "cardProviderRequiredDescription": "بطاقة EXALT غير متاحة بعد. يجب توصيل مزود إصدار بطاقات حقيقي قبل استخدام هذه الميزة.",
  "close": "إغلاق",
  "closed": "مغلق",
  "coin": "العملة",
  "comingSoon": "قريبًا",
  "completed": "مكتمل",
  "confirm": "تأكيد",
  "continue": "متابعة",
  "copy": "نسخ",
  "copyFailed": "فشل النسخ.",
  "copyright": "جميع الحقوق محفوظة.",
  "country": "الدولة",
  "currency": "العملة",
  "date": "التاريخ",
  "delete": "حذف",
  "description": "الوصف",
  "details": "التفاصيل",
  "disabled": "معطل",
  "download": "تنزيل",
  "edit": "تعديل",
  "email": "البريد الإلكتروني",
  "enabled": "مفعل",
  "error": "خطأ",
  "exaltCard": "بطاقة EXALT",
  "exchange": "المنصة",
  "failed": "فشل",
  "fast": "سريع",
  "fillAllRequiredFields": "يرجى تعبئة جميع الحقول المطلوبة.",
  "gated": "محدود",
  "global": "عالمي",
  "inactive": "غير نشط",
  "information": "معلومات",
  "invalidRequest": "طلب غير صالح.",
  "language": "اللغة",
  "languagePreferences": "تفضيلات اللغة",
  "loading": "جاري التحميل...",
  "locked": "مغلق",
  "lockedBalance": "الرصيد المجمد",
  "name": "الاسم",
  "network": "الشبكة",
  "networkError": "خطأ في الشبكة.",
  "next": "التالي",
  "no": "لا",
  "noAssetsFound": "لم يتم العثور على أصول.",
  "noDataFound": "لم يتم العثور على بيانات.",
  "noResultsFound": "لم يتم العثور على نتائج.",
  "noRewardsYet": "لا توجد مكافآت بعد.",
  "noRewardsYetDescription": "ستظهر مكافآت الإحالة والرهان الحقيقية هنا بمجرد كسبها.",
  "notAvailable": "غير متوفر",
  "notVerified": "غير موثق",
  "note": "ملاحظة",
  "notificationCenter": "الإشعارات",
  "open": "مفتوح",
  "openStatus": "مفتوح",
  "pending": "قيد الانتظار",
  "permissionRequired": "ليس لديك إذن لتنفيذ هذا الإجراء.",
  "phone": "الهاتف",
  "pleaseLoginFirst": "يرجى تسجيل الدخول أولاً.",
  "price": "السعر",
  "processing": "جاري المعالجة...",
  "reference": "المرجع",
  "referralProgram": "الإحالة",
  "refresh": "تحديث",
  "refreshing": "جارٍ التحديث...",
  "rejected": "مرفوض",
  "remove": "إزالة",
  "requestFailed": "فشل الطلب.",
  "rewardsCenter": "مركز المكافآت",
  "rewardsUnavailable": "تعذر تحميل مكافآتك في الوقت الحالي.",
  "role": "الدور",
  "save": "حفظ",
  "saving": "جارٍ الحفظ...",
  "search": "بحث",
  "searchAssets": "البحث عن الأصول",
  "secure": "آمن",
  "sending": "جارٍ الإرسال...",
  "serverError": "خطأ في الخادم.",
  "servicesHub": "الخدمات",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "spot": "الفوري",
  "status": "الحالة",
  "submit": "إرسال",
  "submitting": "جارٍ الإرسال...",
  "success": "ناجح",
  "system": "النظام",
  "time": "الوقت",
  "token": "الرمز",
  "total": "الإجمالي",
  "transactionHash": "بصمة المعاملة",
  "type": "النوع",
  "uid": "معرف المستخدم",
  "unauthorized": "غير مصرح",
  "unlocked": "مفتوح",
  "update": "تحديث",
  "upload": "رفع",
  "user": "مستخدم",
  "userId": "معرف المستخدم",
  "value": "القيمة",
  "verified": "موثق",
  "view": "عرض",
  "viewAllNotifications": "عرض جميع الإشعارات",
  "wallet": "المحفظة",
  "walletAddress": "عنوان المحفظة",
  "warning": "تحذير",
  "yes": "نعم"
}